// RITA-1498 (Nutzungserfassung Phase 1b) — Name und Art eines Serveraufrufs (Konzept 3.5).
// Es wird nur der Operationsname gelesen, nie Variablen/Parameter/Antworten. Für REST-Pfade
// werden Ziffern- und UUID-Segmente zu ':id' und der Query-String entfernt.
export const UNKNOWN_NAME = 'unbekannt';
const MAX_NAME_LENGTH = 128;

export type GraphqlKind = 'query' | 'mutation';

export interface GraphqlOperation {
  name: string;
  kind: GraphqlKind;
}

const NAMED_OPERATION = /^\s*(query|mutation|subscription)\s+([A-Za-z_][A-Za-z0-9_]*)/;
const ANONYMOUS_OPERATION = /^\s*(?:(query|mutation|subscription)\s*)?(?:\([^)]*\)\s*)?\{\s*([A-Za-z_][A-Za-z0-9_]*)/;
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DIGITS_ONLY = /^\d+$/;

const kindOf = (keyword: string | undefined): GraphqlKind => (keyword === 'mutation' ? 'mutation' : 'query');

/** Liest Operationsname und Art aus einem GraphQL-Abfragetext (auch anonyme/kompakte Formen). */
export const graphqlOperation = (queryText: unknown): GraphqlOperation => {
  if (typeof queryText !== 'string') return { name: UNKNOWN_NAME, kind: 'query' };
  const named = NAMED_OPERATION.exec(queryText);
  if (named) return { name: named[2].slice(0, MAX_NAME_LENGTH), kind: kindOf(named[1]) };
  const anonymous = ANONYMOUS_OPERATION.exec(queryText);
  if (anonymous) return { name: anonymous[2].slice(0, MAX_NAME_LENGTH), kind: kindOf(anonymous[1]) };
  return { name: UNKNOWN_NAME, kind: 'query' };
};

/** Bildet "METHODE /pfad/:id" ohne Query-String, Anker, Host und Datensatz-Kennungen. */
export const restName = (method: unknown, url: unknown): string => {
  const verb = (typeof method === 'string' && method.length > 0 ? method : 'GET').toUpperCase();
  if (typeof url !== 'string' || url.length === 0) return `${verb} ${UNKNOWN_NAME}`;
  const withoutHost = /^https?:\/\//i.test(url) ? url.replace(/^https?:\/\/[^/]+/i, '') || '/' : url;
  const [withoutHash] = withoutHost.split('#');
  const [path] = withoutHash.split('?');
  if (!path.startsWith('/')) return `${verb} ${UNKNOWN_NAME}`;
  const masked = path
    .split('/')
    .map((segment) => (DIGITS_ONLY.test(segment) || UUID_SEGMENT.test(segment) ? ':id' : segment))
    .join('/');
  return `${verb} ${masked}`.slice(0, MAX_NAME_LENGTH);
};
